exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EditGoalModal-439e6311 .goalImg-c9d24bca{border:2px solid #E0E0E0;border-radius:50%;display:block;margin:0 auto;background:#FFF;object-fit:cover}@media screen and (min-width: 1000px) and (min-height: 680px) and (max-height: 890px){.EditGoalModal-439e6311.newGoal-ef303eb6 form{display:flex;flex-flow:column wrap;align-content:stretch;height:54vh;margin:0 -15px}.EditGoalModal-439e6311.newGoal-ef303eb6 .formGroup-16ea0c15{margin:0 15px;width:calc(50% - 30px);flex:0 1 auto}}\n", ""]);

// Exports
exports.locals = {
	"EditGoalModal": "EditGoalModal-439e6311",
	"goalImg": "goalImg-c9d24bca",
	"newGoal": "newGoal-ef303eb6",
	"formGroup": "formGroup-16ea0c15"
};